import React                                  from 'react';
import PropTypes                              from 'prop-types';
import style                                  from './FeatureFeedback.module.less';
import FeatureFeedbackPopupRatingButtonsLikes from './FeatureFeedbackPopupRatingButtonsLikes.js';

const onPanelClick = (event) => {
	event.preventDefault();
	event.stopPropagation();
};

const FeatureFeedbackPanel = ({isDark, onTogglePopup, rating, title}) => {
	const onTogglePopupClick = (rating) => {
		if (onTogglePopup) {
			onTogglePopup(rating);
		}
	};

	return (
		<div className={isDark ? style.featureFeedbackPanelDark : style.featureFeedbackPanel} onClick={onPanelClick}>
			{title && (
				<span className={style['feature-feedback--panel__collapsable']}>{title}<span className={style['feature-feedback--panel__collapsable__spacer']}></span></span>
			)}
			<FeatureFeedbackPopupRatingButtonsLikes selectedRating={rating} onSelectRating={(rating) => onTogglePopupClick(rating)} />
		</div>
	);
};

// props validation
FeatureFeedbackPanel.propTypes = {
	rating:        PropTypes.string,
	title:         PropTypes.string,
	onTogglePopup: PropTypes.func,
	isDark:        PropTypes.bool,
};

export default FeatureFeedbackPanel;
